import * as React from 'react'

function BottomClouds(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={335.728} height={88.03} viewBox="0 0 335.728 88.03" {...props}>
      <g fill="none" stroke="#263238" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1}>
        <g data-name="Group 51296" opacity={0.6}>
          <path
            data-name="Path 1347"
            d="M142.875 56.007c0-21.731-19.987-15.071-19.987-15.071s3.119-15.485-18.2-15.485C105.911 3.614 70.895-8.686 51.879 7.216"
            transform="translate(-583.021 -872.47) translate(775.375 903.994)"
          />
          <path
            data-name="Path 17167"
            d="M0 56.006c0-13.42 12.343-9.307 12.343-9.307s-1.923-9.558 11.239-9.558c-.857-15.289 27.055-23.009 36.625-6.435"
            transform="translate(-583.021 -872.47) translate(775.375 903.994)"
          />
        </g>
        <g data-name="Group 51295" opacity={0.6}>
          <path
            data-name="Path 17169"
            d="M0 87.007c0-33.76 28.438-23.413 28.438-23.413S24 39.538 54.333 39.538c-1.741-33.924 48.082-53.033 75.139-28.328"
            transform="translate(-583.021 -872.47) translate(583.521 872.993)"
          />
          <path
            data-name="Path 17168"
            d="M221.861 63.734c0-16.85-17.562-11.686-17.562-11.686s2.741-12.006-15.992-12.006c1.219-19.2-38.5-28.889-52.111-8.079"
            transform="translate(-583.021 -872.47) translate(583.521 872.993)"
          />
        </g>
      </g>
    </svg>
  )
}

export default BottomClouds
